<template>
  <div class="o-dashboard">



    <app-navigation :hideAuxNavOnDesktop="true" :currentSpace="$t('web.dashboard.nav_space')">
    </app-navigation>



    <div class="c-dashboard-branding">

      <picture>

        <source :srcset="platformImages.dashboard_branding_desktop + ', ' +
                        platformImages.dashboard_branding_desktop_2x + ' 2x'"
                media="(min-width: 960px)">

        <source :srcset="platformImages.dashboard_branding_tablet + ', ' +
                platformImages.dashboard_branding_tablet_2x  + ' 2x'"
                media="(min-width: 720px)">

        <img :src="platformImages.dashboard_branding_mobile"
             :srcset="platformImages.dashboard_branding_mobile + ', ' +
                     platformImages.dashboard_branding_mobile_2x  + ' 2x'"
             :alt="$t('web.dashboard.alt_text_banner_image')">

      </picture>

    </div>



    <main class="o-dashboard__main">

      <template v-for="card in dashboardLayout">
        <component v-if="typeof cards[card.id] !== 'undefined'"
                   :key="card.id"
                   :is="'card-'+cards[card.id].type"
                   :card="cards[card.id]"
                   :loaded="cardsLoaded.includes(card.id)">
        </component>
      </template>

    </main>



    <app-footer></app-footer>



  </div>
</template>



<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'dashboard',
    data () {
      return {
        cardsLoaded: []
      }
    },
    mounted () {
      this.LOAD_PARTICIPANT(this.$router)
      let cardIds = {}
      this.LOAD_DASHBOARD()
        .then(() => {
          _.each(this.dashboardLayout, card => {
            if (typeof this.cards[card.id] === 'undefined') {
              this.UPDATE_CARD_DETAILS({
                id: card.id,
                type: card.type,
                title: null,
                content: null
              })
            }
            cardIds[card.id] = card.id
          })
          _.each(cardIds, id => {
            this.LOAD_CARD({id: id}).then(() => this.cardsLoaded.push(id))
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    methods: {
      ...mapActions([
        'LOAD_PARTICIPANT',
        'LOAD_DASHBOARD',
        'LOAD_CARD'
      ]),
      ...mapMutations(['UPDATE_CARD_DETAILS'])
    },
    computed: {
      ...mapGetters(['dashboardLayout', 'cards', 'platformImages'])
    }
  }
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// Dashboard.vue?1610185c